import React, { useContext, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import axios from "axios";
import { fmDataContext } from "../../Context/FmData";
import Joi from "joi";
import LoadingCircle from "../LoadingCircle/LoadingCircle";
import { authenticationContext } from "../../Context/AuthContext";
import userCan from "../../helpers/userCan";
import { toast } from "react-toastify";

const CreatePartnership = () => {
  let { baseUrl, navigate } = useContext(fmDataContext);
  let { user } = useContext(authenticationContext);
  let [selectedImage, setSelectedImage] = useState({});

  let [joiErrorsList, setJoiErrorsList] = useState([]);
  let [imageInputError, setImageInputError] = useState(null);
  let [partnershipData, setPartnershipData] = useState({
    name: "",
    about: "",
    image: selectedImage,
    user_id: null,
    facebook_url: null,
    instagram_url: null,
    threads_url: null,
    x_url: null,
    linkedin_url: null,
    website_url: null,
  });

  let [isCreateLoading, setIsCreateLoading] = useState(false);

  let [createResponse, setCreateResponse] = useState({});

  const getPartnershipData = (e) => {
    const partnership = { ...partnershipData };
    partnership[e.target.name] = e.target.value;
    setPartnershipData(partnership);
  };

  const handleImageSelect = (e) => {
    setSelectedImage(e.target.files[0]);
  };

  const createItem = async (e) => {
    e.preventDefault();

    if (userCan("fm_partnership_create")) {
      partnershipData.user_id = user.currentUser._id;
      partnershipData.about = partnershipData.about ? partnershipData.about.replaceAll("\n", "</br>") : "";
      const validationResult = validateCreatePartnershipForm();
      let imageError = null;
      setCreateResponse({});

      if (selectedImage) {
        partnershipData.image = selectedImage;
        if (!partnershipData.image.name) {
          imageError = "Image Input Is Required";
        } else if (!["image/png", "image/jpg", "image/jpeg", "image/gif"].includes(partnershipData.image.type)) {
          imageError = "File must be an Image and from These extensions (png, jpg, jpeg, gif)";
        } else if (partnershipData.image.size > 5 * 1024 * 1024) {
          imageError = "Image Size Must Be Less Than 5 MB";
        }
      } else {
        imageError = "Image Input Is Required";
        partnershipData.image = {};
      }

      if (validationResult.error || imageError) {
        validationResult.error ? setJoiErrorsList(validationResult.error.details) : setJoiErrorsList([]);
        setImageInputError(imageError);
      } else {
        setIsCreateLoading(true);
        setImageInputError(null);
        setJoiErrorsList([]);
        await axios({
          method: "POST",
          url: `${baseUrl}fm-partnerships/create`,
          data: partnershipData,
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            "fm-api-secret-key": process.env.REACT_APP_FM_API_SECRET_KEY,
            Authorization: `Bearer ${user.accessToken}`,
          },
        })
          .then((response) => {
            setCreateResponse(response.data);
            setIsCreateLoading(false);
            if (response.data.msg && response.data.msg.includes("successfully")) {
              setPartnershipData({
                name: "",
                about: "",
                image: {},
                user_id: null,
                facebook_url: null,
                instagram_url: null,
                threads_url: null,
                x_url: null,
                linkedin_url: null,
                website_url: null,
              });
              setSelectedImage({});
              e.target.reset();
              setCreateResponse({});
              toast(response.data.msg, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                progressStyle: { backgroundColor: "#fdb915" },
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "dark",
              });
            } else if (response.data.msg && response.data.msg.includes("failed")) {
              toast(response.data.msg, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                progressStyle: { backgroundColor: "#fdb915" },
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "dark",
              });
            }
          })
          .catch((errors) => {
            navigate("/not-found");
          });
      }
    } else {
      navigate("/not-found");
    }
  };

  const validateCreatePartnershipForm = () => {
    const scheme = Joi.object({
      name: Joi.string().min(1).max(255).required(),
      about: Joi.string().min(1).max(1500).required(),
      image: Joi.any(),
      user_id: Joi.number(),
      facebook_url: Joi.string().pattern(new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|(www\\.)?){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?")).message("Facebook URL is not valid").allow(null, "").optional(),
      instagram_url: Joi.string().pattern(new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|(www\\.)?){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?")).message("Instagram URL is not valid").allow(null, "").optional(),
      threads_url: Joi.string().pattern(new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|(www\\.)?){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?")).message("threads URL is not valid").allow(null, "").optional(),
      x_url: Joi.string().pattern(new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|(www\\.)?){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?")).message("X URL is not valid").allow(null, "").optional(),
      linkedin_url: Joi.string().pattern(new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|(www\\.)?){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?")).message("Linkedin URL is not valid").allow(null, "").optional(),
      website_url: Joi.string().pattern(new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|(www\\.)?){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?")).message("Website URL is not valid").allow(null, "").optional(),
    });
    return scheme.validate(partnershipData, { abortEarly: false });
  };

  return (
    <>
      <div className="container position-relative pt-3 pt-md-4">
        <div className="mb-3 mb-md-4">
          <h1 className="fu-text-3-rem fu-text-3-rem-md fu-text-md-2-rem fu-text-sm-2-rem fu-text-1-8-rem-xs fu-text-18-px-xxs fu-text-16-px-xxs fu-fw-800 fu-text-white mb-0">Create Partnership</h1>
        </div>
        <div className="py-2 mb-4 iu-row-heading create-submit-row">
          <h2 className="mb-0 row-title">Submit New Partnership To Partnerships List</h2>
        </div>
        <div className="row">
          <div>
            <div>
              <Form onSubmit={createItem}>
                <Row>
                  <Col lg={6}>
                    <Form.Group className="mb-3" controlId="partnershipName">
                      <Form.Label className="fu-text-light-gray" data-title="required">
                        Partnership Name
                        <span className="required-input mx-1" data-title="required">
                          *
                        </span>
                      </Form.Label>
                      <Form.Control type="text" placeholder="Enter Partnership Name" className="fu-input" name="name" onInput={getPartnershipData} autoComplete="on" />
                      {joiErrorsList.map((error, index) =>
                        error.path[0] === "name" ? (
                          <div key={index} className="alert alert-danger py-1 px-2 mt-2 mb-0">
                            {error.message.replace("name", "Partnership name")}
                          </div>
                        ) : (
                          ""
                        )
                      )}
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mb-3" controlId="partnershipImage">
                      <Form.Label className="fu-text-light-gray" data-title="required">
                        Partnership Image
                        <span className="required-input mx-1" data-title="required">
                          *
                        </span>
                      </Form.Label>
                      <Form.Control type="file" placeholder="choose Partnership Image" className="fu-input" name="image" onInput={handleImageSelect} />
                      {imageInputError !== null ? <div className="alert alert-danger py-1 px-2 mt-2 mb-0">{imageInputError}</div> : ""}
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group className="mb-3" controlId="aboutPartnership">
                  <Form.Label className="fu-text-light-gray" data-title="required">
                    About Partnership
                    <span className="required-input mx-1" data-title="required">
                      *
                    </span>
                  </Form.Label>
                  <div className="textarea-container">
                    <Form.Control as="textarea" rows={4} className="fu-input" placeholder="Enter Partnership Bio" name="about" onInput={getPartnershipData} />
                  </div>
                  {joiErrorsList.map((error, index) =>
                    error.path[0] === "about" ? (
                      <div key={index} className="alert alert-danger py-1 px-2 mt-2 mb-0">
                        {error.message.replace("about", "Partnership about")}
                      </div>
                    ) : (
                      ""
                    )
                  )}
                </Form.Group>
                {/* ------------------------------------ */}
                <Row>
                  <Col lg={6}>
                    <Form.Group className="mb-3" controlId="facebookUrl">
                      <Form.Label className="fu-text-light-gray" data-title="optional">
                        FaceBook URL
                        <span className="optional-input mx-1" data-title="optional">
                          *
                        </span>
                      </Form.Label>
                      <Form.Control type="text" placeholder="Enter Partnership FaceBook URL" className="fu-input" name="facebook_url" onInput={getPartnershipData} />
                      {joiErrorsList.map((error, index) =>
                        error.path[0] === "facebook_url" ? (
                          <div key={index} className="alert alert-danger py-1 px-2 mt-2 mb-0">
                            {error.message.replaceAll("_", " ")}
                          </div>
                        ) : (
                          ""
                        )
                      )}
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mb-3" controlId="instagramUrl">
                      <Form.Label className="fu-text-light-gray" data-title="optional">
                        Instagram URL
                        <span className="optional-input mx-1" data-title="optional">
                          *
                        </span>
                      </Form.Label>
                      <Form.Control type="text" placeholder="Enter Partnership Instagram URL" className="fu-input" name="instagram_url" onInput={getPartnershipData} />
                      {joiErrorsList.map((error, index) =>
                        error.path[0] === "instagram_url" ? (
                          <div key={index} className="alert alert-danger py-1 px-2 mt-2 mb-0">
                            {error.message.replaceAll("_", " ")}
                          </div>
                        ) : (
                          ""
                        )
                      )}
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mb-3" controlId="threadsUrl">
                      <Form.Label className="fu-text-light-gray" data-title="optional">
                        Threads URL
                        <span className="optional-input mx-1" data-title="optional">
                          *
                        </span>
                      </Form.Label>
                      <Form.Control type="text" placeholder="Enter Partnership Threads URL" className="fu-input" name="threads_url" onInput={getPartnershipData} />
                      {joiErrorsList.map((error, index) =>
                        error.path[0] === "threads_url" ? (
                          <div key={index} className="alert alert-danger py-1 px-2 mt-2 mb-0">
                            {error.message.replaceAll("_", " ")}
                          </div>
                        ) : (
                          ""
                        )
                      )}
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mb-3" controlId="xUrl">
                      <Form.Label className="fu-text-light-gray" data-title="optional">
                        X URL
                        <span className="optional-input mx-1" data-title="optional">
                          *
                        </span>
                      </Form.Label>
                      <Form.Control type="text" placeholder="Enter Partnership X URL" className="fu-input" name="x_url" onInput={getPartnershipData} />
                      {joiErrorsList.map((error, index) =>
                        error.path[0] === "x_url" ? (
                          <div key={index} className="alert alert-danger py-1 px-2 mt-2 mb-0">
                            {error.message.replaceAll("_", " ")}
                          </div>
                        ) : (
                          ""
                        )
                      )}
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mb-3" controlId="linkedInUrl">
                      <Form.Label className="fu-text-light-gray" data-title="optional">
                        LinkedIn URL
                        <span className="optional-input mx-1" data-title="optional">
                          *
                        </span>
                      </Form.Label>
                      <Form.Control type="text" placeholder="Enter Partnership LinkedIn URL" className="fu-input" name="linkedin_url" onInput={getPartnershipData} />
                      {joiErrorsList.map((error, index) =>
                        error.path[0] === "linkedin_url" ? (
                          <div key={index} className="alert alert-danger py-1 px-2 mt-2 mb-0">
                            {error.message.replaceAll("_", " ")}
                          </div>
                        ) : (
                          ""
                        )
                      )}
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mb-3" controlId="websiteUrl">
                      <Form.Label className="fu-text-light-gray" data-title="optional">
                        Website URL
                        <span className="optional-input mx-1" data-title="optional">
                          *
                        </span>
                      </Form.Label>
                      <Form.Control type="text" placeholder="Enter Partnership Website URL" className="fu-input" name="website_url" onInput={getPartnershipData} />
                      {joiErrorsList.map((error, index) =>
                        error.path[0] === "website_url" ? (
                          <div key={index} className="alert alert-danger py-1 px-2 mt-2 mb-0">
                            {error.message.replaceAll("_", " ")}
                          </div>
                        ) : (
                          ""
                        )
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                {createResponse.errors
                  ? Object.keys(createResponse.errors).map((key) =>
                      createResponse.errors[key].map((error, index) => (
                        <div key={index} className="alert alert-danger py-1 px-2 mt-2 mb-0">
                          {error}
                        </div>
                      ))
                    )
                  : ""}
                <div className="d-flex align-items-center mt-4">
                  <div>
                    <Button className={`fu-btn fu-btn-gray ${isCreateLoading ? "disabled" : ""}`} type="submit" disabled={isCreateLoading ? true : false}>
                      <span className="btn-bg"></span>
                      Submit<i className="bi bi-send ms-2"></i>
                    </Button>
                  </div>
                  {isCreateLoading ? (
                    <div className="position-relative ms-3">
                      <LoadingCircle circleCont={35} icon={30} loader={35} dot={35} />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreatePartnership;
